import { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import useTaskResult from './useTaskResult'
import { base64ToBlob, triggerBlobDownload } from '../utils/downloadArtifact'
import { ArtifactResult } from '../api/celeryClient'

interface UseArtifactDownloadOptions {
    getFilename: (result: ArtifactResult) => string
    successMessage: string
    processErrorMessage?: string
    failureMessage?: string
    defaultContentType?: string
}

export function useArtifactDownload({
    getFilename,
    successMessage,
    processErrorMessage = 'Erro ao processar o ficheiro gerado',
    failureMessage = 'Erro ao gerar o ficheiro. Por favor tente mais tarde',
    defaultContentType = 'application/octet-stream',
}: UseArtifactDownloadOptions) {
    const alert = useAlert()
    const [taskId, setTaskId] = useState<string | null>(null)
    const { state, result, error } = useTaskResult(taskId ?? undefined)

    const startTask = (id: string) => {
        setTaskId(id)
        alert.success(successMessage)
    }

    useEffect(() => {
        if (state === 'SUCCESS' && result) {
            try {
                const contentType = result.content_type || defaultContentType
                const blob = base64ToBlob(result.content_base64, contentType)
                triggerBlobDownload(blob, getFilename(result))
            } catch (e) {
                alert.error(processErrorMessage)
            } finally {
                setTaskId(null)
            }
        } else if (state === 'FAILURE') {
            alert.error(error || failureMessage)
            setTaskId(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, result, error])

    return { busy: taskId !== null, startTask }
}

export default useArtifactDownload
